export const COOKIES_KEYS = {
  SWITCH_DASHBOARDS_TOKEN: 'switch_dashboards_token',
  SWITCH_DASHBOARDS_LANGUAGE: 'switch_dashboards_language',
  SWITCH_DASHBOARDS_MODE: 'switch_dashboards_mode',
  IS_LIVE_MODE: 'is_live_mode',
  PAYMOB_PRO_TOKEN: 'paymob_pro_token',
  PAYMOB_PRO_REFRESH_TOKEN: 'paymob_pro_refresh_token',
};
